"use client";

import { signOut, useSession } from "next-auth/react";
import Link from "next/link";
import { useEffect, useRef, useCallback } from "react";

const DEMO_INACTIVITY_TIMEOUT = 15 * 60 * 1000;

export function DemoBanner() {
  const { data: session } = useSession();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      signOut({ callbackUrl: "/" });
    }, DEMO_INACTIVITY_TIMEOUT);
  }, []);

  useEffect(() => {
    if (!session?.user?.demoMode) return;

    const events = ["mousedown", "keydown", "scroll", "touchstart", "mousemove"];
    events.forEach((e) => window.addEventListener(e, resetTimer, { passive: true }));
    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((e) => window.removeEventListener(e, resetTimer));
    };
  }, [session?.user?.demoMode, resetTimer]);

  if (!session?.user?.demoMode) return null;

  return (
    <div className="relative z-[90] w-full">
      <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
        <div className="mx-auto max-w-7xl px-3 py-1.5 sm:px-4 sm:py-2">
          <div className="flex items-center justify-between gap-2 text-xs sm:justify-center sm:gap-3 sm:text-sm">
            <div className="flex items-center gap-1.5 sm:gap-2">
              <span className="hidden h-5 w-5 items-center justify-center rounded-full bg-white/20 text-xs sm:inline-flex">i</span>
              <span className="font-medium">Read-only demo — changes won&apos;t be saved</span>
            </div>
            <Link
              href="/signup"
              className="inline-flex shrink-0 items-center gap-1 rounded-full bg-white px-3 py-1 text-xs font-semibold text-blue-700 transition-colors hover:bg-blue-50 sm:px-4 sm:text-sm"
            >
              Get Started Free
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
